<template>
  <div class="binding-account-page" v-show="show">
    <div class="title">账号绑定</div>
    <div class="content">
      <van-form
        ref="form"
        @submit="onSubmit"
        @failed="onFailed"
        :show-error="false"
        :show-error-message="false"
      >
        <div class="form-list-item">
          <div class="item-title">手机号</div>
          <div class="item-content">
            <van-field
              v-model="phone"
              name="phone"
              placeholder="请输入手机号"
              @input="fieldInput"
              :rules="[{ required: true, pattern: phonePattern }]"
            />
          </div>
        </div>
        <div class="form-list-item">
          <div class="item-title">验证码</div>
          <div class="item-content">
            <van-field
              v-model="smsCode"
              name="smsCode"
              placeholder="请输入验证码"
              @input="fieldInput"
              :rules="[{ required: true, pattern: smsCodePattern }]"
            />
            <div class="get-smsCode-btn" @click="getCode" v-if="isSmsCodeBtnActive">获取验证码</div>
            <div class="get-smsCode-btn" :class="isSmsCodeBtnActive ? '' : 'no-active-btn'" v-else>
              {{ smsCodeCount }}秒
            </div>
          </div>
        </div>
         <div class="sliderCode" v-show="sliderVer">
                <div id="MyDomId" class="nc-container"></div>
              </div>

        <div class="footer">
          <div class="form-btn" @click="submitClick" :class="btnActivity ? '' : 'no-activity-btn'">
            立即绑定
          </div>
        </div>
      </van-form>
    </div>
    <toast ref="toast" />
  </div>
</template>

<script>
import { getWechatAppId } from '@/utils/tools';
// eslint-disable-next-line import/extensions
import toast from '@/components/wxchatBinding/toast';
import { reqWeChatBind } from '@/api/wechatServiceNum';
import { reqPhonesliderCode } from '@/api/login';

export default {
  components: {
    toast,
  },
  data() {
    return {
      phone: '',
      smsCode: '',
      wxInfo: {},
      phonePattern: /\d{11}/,
      smsCodePattern: /\d{4}/,
      clickCount: 0,
      timer: null,
      smsCodeCount: 60,
      isSmsCodeBtnActive: true, // 验证码按钮状态
      btnActivity: false, // 按钮状态
      show: false,
       tagNcFlag: false, // 滑块是否存在
       sliderVer: false, // 是否显示滑块验证（显示/隐藏）
    };
  },
  mounted() {
    if (this.$route.query.state && this.$route.query.state === 'weixinredirect') {
      this.wxInfo = this.$route.query;
    }
    setTimeout(() => {
      this.show = true;
      this.useNvc();
    }, 500);
  },
  methods: {
    // 表单输入时验证正则，判断按钮状态
    fieldInput() {
      this.$refs.form
        .validate()
        .then(() => {
          this.btnActivity = true;
        })
        .catch(() => {
          this.btnActivity = false;
        });
    },

    // 验证码倒计时
    getCodeTime() {
      if (!this.timer) {
        const TIME_COUNT = 60;
        this.smsCodeCount = TIME_COUNT;
        this.isSmsCodeBtnActive = false;
        this.timer = setInterval(() => {
          if (this.smsCodeCount > 0 && this.smsCodeCount <= TIME_COUNT) {
            // eslint-disable-next-line no-plusplus
            this.smsCodeCount--;
          } else {
            this.isSmsCodeBtnActive = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    // 发送验证码
    getCode() {
      const userPhone = String(this.phone);
      const isPhone = /\d{11}/.test(userPhone);

      if (isPhone) {
        const _this = this;
        window.nvc.getNVCValAsync((nvcVal) => {
          _this.getNewVerification(nvcVal);
        });
      } else {
        this.$toast('请输入正确格式的手机号');
      }
    },
    useNvc() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      // 实例化nvc 对无痕验证进行初始化操作
      // eslint-disable-next-line no-undef
      AWSC.use('nvc', (state, module) => {
        // 初始化 调用module.init进行初始化
        window.nvc = module.init({
          // 应用类型标识。它和使用场景标识（scene字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
          appkey: 'FFFF0N0000000000ACF9',
          // 使用场景标识。它和应用类型标识（appkey字段）一起决定了无痕验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
          scene: 'nvc_message_h5',
          // scene: 'module.TEST_NC_PASS',
          // test: module.TEST_BLOCK,
          // test: module.TEST_NC_PASS,
          // test: module.TEST_NC_BLOCK,
          // // 二次验证(滑块验证成功)获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
          success(data) {
            // 滑块验证成功
            _this.getNewVerification(data);
          },
          // 前端二次验证失败时触发该回调参数
          fail() {
            this.$toast('验证失败，请刷新页面重新尝试');
          },
          // 前端二次验证加载异常时触发该回调参数。
          error(errorCode) {
            console.log(errorCode);
          },
        });
      });
    },
    // 发送验证码
    async getNewVerification(nvcVal) {
      const data = {
        company: 0,
        type: 'binding',
        phone: String(this.phone) || '',
        nvcVal,
      };
      const res = await reqPhonesliderCode(data);
      if (res.code === 0) {
        if (res.data.status === 0) {
          if (this.clickCount < 5) {
            this.getCodeTime();
            this.clickCount += 1;
          } else if (this.clickCount > 5) {
            this.$refs.toast.toastShow({
              type: 'warn',
              text: '操作过于频繁，请5分钟后尝试',
            });
            setTimeout(() => {
              this.clickCount = 0;
            }, 300000);
          } else {
            this.$refs.toast.toastShow({
              type: 'warn',
              text: data.msg,
            });
          }
        } else if (res.data.status === 1) {
          // 业务服务器请求回调控制是否需要二次验证
          if (res.data.bizCode === 800 || res.data.bizCode === 900) {
            // 无痕验证失败，直接拦截
            this.$toast('验证失败，请重新尝试');
          } else if (res.data.bizCode === 400) {
            this.sliderVer = true;
            // console.log(this.tagNcFlag, 'this.tagNcFlag');
            if (!this.tagNcFlag) {
              // // 无痕验证失败，需要触发二次滑块验证
              const ncoption = {
                // 二次验证文案配置
                renderTo: '#MyDomId',
                upLang: {
                  cn: {
                    // 加载状态提示。
                    LOADING: '加载中...',
                    // 等待滑动状态提示。
                    SLIDE: '请按住滑块，拖动到最右边',
                    // 验证通过状态提示。
                    SUCCESS:
                      "<a style='margin-left:30px;-webkit-text-fill-color: #fff;'>验证通过</a>",
                    // 验证失败触发拦截状态提示。
                    ERROR:
                      '滑动失败，请重新滑动,点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                    // 验证失败触发拦截状态提示。
                    FAIL: '验证失败，请点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                  },
                },
              };
              // 唤醒二次验证（滑动验证码）
              window.nvc.getNC(ncoption);
              this.tagNcFlag = true;
            }
          }
        }
      } else {
        this.$toast(res.msg);
        this.sliderVer = false;
        window.nvc.reset();
      }
    },

    submitClick() {
      this.$refs.form.submit();
    },

    async onSubmit(values) {
      const wechatAppId = await getWechatAppId('binding');
      if (!this.btnActivity) {
        return;
      }
      this.btnActivity = false;
      const param = {
        appId: wechatAppId,
        code: this.wxInfo.code,
        phone: values.phone,
        smsCode: values.smsCode,
      };
      const response = await reqWeChatBind(param);
      if (response.code === 0) {
        this.$refs.toast.toastShow({
          type: 'success',
          text: '绑定成功',
        });
        setTimeout(() => {
          this.btnActivity = true;
          // 绑定成功跳转解绑页面
          this.$emit('bindingSuccess', response.data);
        }, 1000);
      } else if (response.code === 6061) {
        // 微信code失效
        this.$toast('页面停留时间长');
        setTimeout(() => {
          this.btnActivity = true;
          this.$parent.wechatAuth();
        }, 1000);
      } else {
        this.btnActivity = true;
        this.$toast(response.msg);
      }
    },

    onFailed(val) {
      this.$refs.toast.toastShow({
        type: 'warn',
        text: val.errors[0].message,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.binding-account-page {
  margin: 0 64px;
  overflow: auto;

  .title {
    margin-top: 200px;
    color: #313131;
    font-weight: bold;
    font-size: 40px;
    line-height: 56px;
  }

  .content {
    ::v-deep .van-cell {
      background: rgba(0, 0, 0, 0);

      &::after {
        border: 0;
      }
    }
    .form-list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 74px;

      .item-title {
        color: #313131;
        font-weight: 400;
        font-size: 28px;
        line-height: 72px;
        white-space: nowrap;
      }

      .item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 495px;
        border-bottom: 2px solid #f5f5f5;
      }

      .get-smsCode-btn {
        height: 48px;
        padding: 8px 16px;
        color: #ff8100;
        font-weight: 400;
        font-size: 24px;
        line-height: 32px;
        white-space: nowrap;
        border: 2px solid #ff8100;
        border-radius: 8px;
      }

      .no-active-btn {
        color: #787878;
        border-color: #787878;
      }
    }
  }

  .footer {
    margin-top: 120px;

    .form-btn {
      height: 88px;
      color: white;
      font-size: 32px;
      line-height: 88px;
      text-align: center;
      background: #ff8100;
      border-radius: 12px;
    }

    .no-activity-btn {
      background: #fdd8b5;
    }
  }
}
</style>
<style lang="scss" scoped>
.binding-account-page {
  input {
    font-size: 28px;
  }
}
.sliderCode {
  height: 70px;
  margin: 20px 0 0 0;
}

::v-deep .nc-container .nc_scale .btn_ok,
::v-deep .nc-container .nc_scale span {
  height: 68px !important;
}
._nc .stage1 .slider {
  height: 52px !important;
  background-color: #ddd !important;
  border-radius: 0 !important;
  box-shadow: 0 0 3px #999 !important;
}
._nc .stage1 .track div {
  color: #fff !important;
  border-radius: 0 !important;
}
.nc .stage1 .bg-green {
  background-color: #78c430 !important;
}
.nc .stage1 .bg-red {
  background-color: #78c430 !important;
}
</style>
